import React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { ButtonVariant } from '../Button';
import { StyledDialogButton } from '../Dialog/StyledDialogButton';
import { StyledPrompt } from './StyledPrompt';

type StyledNavigationPromptProps = {
    when: boolean;
    onSave?(): void;
    onCancel?(): void;
    onConfirm?(): void;
};

export class StyledNavigationPrompt extends React.Component<StyledNavigationPromptProps> {
    public handleSave = (onConfirm: () => void, onCancel: () => void) => () => {
        if (this.props.onSave) {
            this.props.onSave();
            onCancel();
        }
    };

    public handleCancel = (navigationPromptCancel: () => void) => () => {
        navigationPromptCancel();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    };

    public handleConfirm = (navigationPromptConfirm: () => void) => () => {
        navigationPromptConfirm();
        if (this.props.onConfirm) {
            this.props.onConfirm();
        }
    };

    public render() {
        if (!this.props.when) return null;

        return (
            <NavigationPrompt {...this.props} renderIfNotActive={false}>
                {({ onConfirm, onCancel }) => (
                    <StyledPrompt
                        open
                        title={'Save changes?'}
                        onCancel={onCancel}
                        actions={[
                            <StyledDialogButton
                                title='Cancel'
                                key='keep-user-file-changes'
                                variant={ButtonVariant.light}
                                onClick={this.handleCancel(onCancel)}
                                testId='cancel'
                            >
                                Cancel
                            </StyledDialogButton>,
                            <StyledDialogButton
                                title='Discard'
                                key='discard-user-file-changes'
                                onClick={this.handleConfirm(onConfirm)}
                                testId='discard'
                            >
                                Discard
                            </StyledDialogButton>,
                            this.props.onSave && (
                                <StyledDialogButton
                                    title='Save'
                                    key='save-user-file-changes'
                                    onClick={this.handleSave(onConfirm, onCancel)}
                                    testId='save'
                                >
                                    Save
                                </StyledDialogButton>
                            )
                        ]}
                    >
                        Unsaved changes will be lost.
                    </StyledPrompt>
                )}
            </NavigationPrompt>
        );
    }
}
